<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="outsourcing-batch-import-dialog ah-detail-dialog"
        :width="fileName ? null : '660px'"
        top="10vh"
        :before-close="() => onClose()"
        :show-close="false"
        @open="onOpen"
    >
        <template slot="title">批次匯入帳號</template>
        <div v-if="!fileName" class="detail-row no-padding">
            <uploadFileView @updateSheet="onUpdateSheet" @updateFileName="onUpdateFileName" @import="onImport" @close="onClose" />
        </div>
        <div v-else class="detail-row">
            <checkView :sheetToImport="sheetToImport" />
        </div>
        <div class="detail-row footer right" v-if="fileName">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <template v-if="importStatus === 'init'">
                    <div>
                        <el-button plain @click="onUpdateFileName(null)">重新上傳 Excel 檔案</el-button>
                        <el-button plain @click="onClose()">取消</el-button>
                    </div>
                    <div>
                        <el-button type="primary" @click="onImport">開始新增 {{ sheetToImport.length }} 筆資料</el-button>
                    </div>
                </template>
                <template v-else>
                    <div style="flex:0.9">
                        <el-progress :percentage="processPercentage" :color="processPercentage === 100 ? '#92DE56' : '#463cb2'"></el-progress>
                    </div>
                    <div v-if="importStatus === 'importing'">
                        <el-button :loading="isStopped" plain @click="onStop">
                            <span v-if="!isStopped">停止</span>
                            <span v-else>停止中</span>
                        </el-button>
                    </div>
                    <div v-else>
                        <el-button type="primary" @click="onClose(true)">完成</el-button>
                    </div>
                </template>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import uploadFileView from '@/components/dashboard/Settings/UserSetting/BatchImportDialogViews/uploadFileView.vue';
import checkView from '@/components/dashboard/Settings/UserSetting/BatchImportDialogViews/checkView.vue';
import stMap from '@/components/dashboard/Settings/UserSetting/BatchImportDialogViews/labelFieldMap';
import { isNationalIdentificationNumberValid } from 'taiwan-id-validator';

export default {
    props: { visible: Boolean },
    components: { uploadFileView, checkView },
    data() {
        return {
            importStatus: 'init',
            isStopped: false,
            fileName: null,
            sheetToImport: [],

            processPercentage: 0,

            staffList: [],
            depListResp: [],
            roleList: [],
        };
    },
    computed: {
        options() {
            return this.type === 'vd' ? this.options_VD : this.options_OS;
        },
    },
    methods: {
        onOpen() {
            this.fetchOptions();
            this.importStatus = 'init';
            this.isStopped = false;
            this.fileName = null;
            this.sheetToImport = [];
            this.processPercentage = 0;
        },
        onClose(refresh) {
            this.$emit('close', refresh);
        },
        async fetchOptions() {
            const staffListResp = await this.$api({
                url: '/StaffManagementPage/GetStaffList',
                params: {
                    PageSize: 999,
                    PageNum: 1,
                    ONF: 1,
                },
                method: 'GET',
            });
            this.staffList = staffListResp.data.staffs.reverse().filter((x) => x.sno !== 1);

            const depListResp = await this.$api({
                url: '/DepartmentSettingPage/GetDepartmentSettings',
                method: 'GET',
            });
            this.depListResp = depListResp.data.departmentSettings;

            const roleListResp = await this.$api({
                url: '/StaffManagementPage/GetRoleOptions',
                method: 'GET',
            });
            this.roleList = roleListResp.data.options;
        },
        async onImport() {
            this.importStatus = 'importing';
            const TOTAL_LENGTH = this.sheetToImport.length;
            let currentProcessedDataCount = 0;

            // eslint-disable-next-line no-restricted-syntax
            for (const data of this.sheetToImport) {
                if (this.isStopped) break;
                try {
                    data.importStatus = 'importing';

                    currentProcessedDataCount += 1;
                    this.processPercentage = Math.round((currentProcessedDataCount / TOTAL_LENGTH) * 100);

                    // eslint-disable-next-line no-await-in-loop
                    await this.$api_silent({
                        url: 'StaffManagementPage/insertStaff',
                        // eslint-disable-next-line no-await-in-loop
                        data: await this.getMapData(data),
                        method: 'POST',
                    });

                    // 更新員工列表
                    // eslint-disable-next-line no-await-in-loop
                    const staffListResp = await this.$api({
                        url: '/StaffManagementPage/GetStaffList',
                        params: {
                            PageSize: 999,
                            PageNum: 1,
                            ONF: 1,
                        },
                        method: 'GET',
                    });
                    this.staffList = staffListResp.data.staffs.reverse().filter((x) => x.sno !== 1);

                    data.importStatus = '已新增';
                } catch (e) {
                    console.log(e);
                    if (!e.response) data.importStatus = e.msg;
                    else if (e.response.status === 400) data.importStatus = '缺少欄位';
                    else if (e.response.status === 500) data.importStatus = e.response.data;
                }
            }

            this.importStatus = 'complete';
        },
        onStop() {
            this.isStopped = true;
        },
        onUpdateSheet(sheet) {
            const SHEET = _.chain(sheet)
                .map((o) => _.mapKeys(o, (v, k) => k.replace('*', '').split(/\n|\r\n/)[0]))
                .map((o) => ({ ...o, importStatus: 'init' }))
                .filter((o) => o['帳號類型'])
                .value();
            console.log(SHEET);
            this.sheetToImport = SHEET;
        },
        onUpdateFileName(nam) {
            this.fileName = nam;
        },
        async getMapData(o) {
            const COMMON_REQUIRE_FIELD_LIST = [stMap.typ, stMap.nam, stMap.idNumber];
            const FILED_WORD_LIMIT_MAP = [
                // { field: stMap.typ, limit: 50 },
                // { field: stMap.employee, limit: 20 },
                // { field: stMap.eml, limit: 100 },
                // { field: stMap.nam, limit: 200 },
                // { field: stMap.idNumber, limit: 30 },
                { field: stMap.pJ_NO, limit: 2 },
                // { field: stMap.deP_SNO, limit: 20 },
                // { field: stMap.boS_SNO, limit: 10 },
                // { field: stMap.mem, limit: 100 },
                // { field: stMap.stafF_BNK_BOO, limit: 100 },
                // { field: stMap.stafF_BNK_DOO, limit: 100 },
                { field: stMap.stafF_BNK_ACC, limit: 20 },
                // { field: stMap.stafF_BNK_TPC, limit: 50 },
                // { field: stMap.grP_NO, limit: 100 },
            ];

            // eslint-disable-next-line camelcase
            const boS_SNO = this.getBosSno(o[stMap.boS_SNO], o[stMap.employee]);
            // eslint-disable-next-line camelcase
            const deP_SNO = await this.getDepSno(o[stMap.deP_SNO], o[stMap.typ], o[stMap.employee]);
            // eslint-disable-next-line camelcase
            const grP_NO = this.getGrpNo(o[stMap.grP_NO], o[stMap.employee]);
            // eslint-disable-next-line camelcase
            const untList = this.getUnList(o[stMap.grP_NO], o[stMap.employee]);

            // eslint-disable-next-line camelcase
            this.checkValidData(o, COMMON_REQUIRE_FIELD_LIST, FILED_WORD_LIMIT_MAP, { boS_SNO, deP_SNO, grP_NO });

            const DATA = {
                adm: 0,
                boS_DEP_SNO: '',
                boS_SNO,
                deP_SNO,
                eml: o[stMap.eml],
                employee: o[stMap.employee] !== '員工收款帳號',
                grP_NO,
                idNumber: o[stMap.idNumber],
                mem: o[stMap.mem],
                nam: o[stMap.nam],
                onf: 1,
                pJ_NO: this.getPjNo(o[stMap.pJ_NO], o[stMap.employee]),
                sno: null,
                stafF_BNK_ACC: this.getStafF_BNK_INFO(o, 'stafF_BNK_ACC'),
                stafF_BNK_BOO: this.getStafF_BNK_INFO(o, 'stafF_BNK_BOO'),
                stafF_BNK_DOO: this.getStafF_BNK_INFO(o, 'stafF_BNK_DOO'),
                stafF_BNK_TPC: this.getStafF_BNK_INFO(o, 'stafF_BNK_TPC'),
                typ: o[stMap.typ] === 'sokuji帳號' ? 1 : 2,
                untList,
            };

            return DATA;
        },

        // eslint-disable-next-line camelcase
        checkValidData(o, requireFieldList, fieldWordLimitMap, { boS_SNO, deP_SNO, grP_NO }) {
            const isSystemAccount = o[stMap.typ] === 'sokuji帳號';
            const isExternalAccount = o[stMap.employee] === '員工收款帳號';

            // 檢查必填欄位
            requireFieldList.forEach((item) => {
                // eslint-disable-next-line no-throw-literal
                if (!o[item]) throw { msg: '缺少必填欄位，請檢查後重新上傳' };
            });

            // 檢查字數
            fieldWordLimitMap.forEach((item) => {
                // eslint-disable-next-line no-throw-literal
                if (o[item.field]?.length > item.limit) throw { msg: `「${item.field}」超過字數上限：${item.limit}` };
            });

            // 檢查缺少欄位
            if (!isExternalAccount) {
                // eslint-disable-next-line no-throw-literal, camelcase
                if (!boS_SNO) throw { msg: '請先建立主管帳號' };
                // eslint-disable-next-line no-throw-literal, camelcase
                if (!deP_SNO) throw { msg: '部門未填寫' };
            }

            if (isSystemAccount && !isExternalAccount) {
                // eslint-disable-next-line no-throw-literal, camelcase
                if (!grP_NO) throw { msg: '身份功能填寫有誤' };
            }

            // eslint-disable-next-line no-throw-literal, camelcase
            if (grP_NO && !(grP_NO === 'STA' || grP_NO === 'ELS') && (!o[stMap.pJ_NO] || o[stMap.pJ_NO]?.length !== 2)) throw { msg: '專案代碼有誤' };

            // 檢查身分證字號
            // eslint-disable-next-line no-throw-literal
            if (!isNationalIdentificationNumberValid(o[stMap.idNumber])) throw { msg: '身分證號碼格式不正確' };

            // 檢查銀行、分行代碼字數
            // eslint-disable-next-line no-throw-literal
            if (o[stMap.stafF_BNK_DOO] && o[stMap.stafF_BNK_DOO].length !== 7) throw { msg: '分行代碼格式錯誤' };
            // eslint-disable-next-line no-throw-literal
            if (o[stMap.stafF_BNK_BOO] && o[stMap.stafF_BNK_BOO].length !== 3) throw { msg: '銀行代碼格式錯誤' };
        },
        getBosSno(bos, employee) {
            if (employee === '員工收款帳號') return null;
            return _.find(this.staffList, ['nam', bos])?.sno;
        },
        async getDepSno(dep, typ, employee) {
            if (employee === '員工收款帳號' || !dep) return null;
            const DEP = dep.trim();
            const FOUND = _.find(this.depListResp, ['deP_NAM', DEP]);
            console.log('DEP', FOUND);
            if (!FOUND) {
                await this.$api({
                    url: '/DepartmentSettingPage/UpsertDepartmentSettings',
                    method: 'post',
                    data: {
                        departmentSettings: [...this.depListResp, { sno: null, deP_NAM: DEP, sot: 0 }],
                    },
                });
                const depListResp = await this.$api({
                    url: '/DepartmentSettingPage/GetDepartmentSettings',
                    method: 'GET',
                });
                this.depListResp = depListResp.data.departmentSettings;
            }
            return _.find(this.depListResp, ['deP_NAM', DEP])?.sno;
        },
        getGrpNo(grp, employee) {
            if (employee === '員工收款帳號') return 'ELS';
            return _.find(this.roleList, ['grP_NAM', grp])?.grP_NO;
        },
        getPjNo(pjNo, employee) {
            if (employee === '員工收款帳號') return null;
            return pjNo ? pjNo.toUpperCase() : null;
        },
        getStafF_BNK_INFO(o, field) {
            if (o[stMap.typ] !== 'sokuji帳號' || o[stMap.employee] === '員工收款帳號') return null;
            return o[stMap[field]];
        },
        getUnList(grp, employee) {
            if (employee === '員工收款帳號') {
                return [
                    'Q01',
                    'Q02',
                    'Q03',
                    'Q04',
                    'F04',
                    'F13',
                    'E02',
                    'E01',
                    'E03',
                    'F03',
                    'F05',
                    'F14',
                    'F23',
                    'E04',
                    'F24',
                    'D22',
                    'D23',
                    'D11',
                    'D12',
                    'D13',
                    'D14',
                    'D15',
                    'D16',
                    'D17',
                    'D18',
                    'D19',
                    'D20',
                    'G03',
                    'D21',
                    'G04',
                    'G05',
                    'G01',
                    'G02',
                    'G06',
                    'G11',
                    'G12',
                    'G07',
                    'G08',
                    'G09',
                    'G10',
                ];
            }
            switch (grp) {
            case '員工':
                return ['A01', 'B01'];
            case '專案經理':
                return ['A01', 'B01', 'C01', 'C05'];
            case '財務管理':
                return [
                    'A01',
                    'A02',
                    'A03',
                    'B01',
                    'B02',
                    'B03',
                    'C02',
                    'C03',
                    'C06',
                    'D21',
                    'D22',
                    'D23',
                    'E01',
                    'E02',
                    'E03',
                    'E04',
                    'F01',
                    'F02',
                    'F03',
                    'F04',
                    'F05',
                    'F13',
                    'F14',
                    'F22',
                    'F23',
                    'F24',
                    'G03',
                    'G04',
                    'G05',
                ];
            case '老闆':
                return [
                    'A01',
                    'B01',
                    'C01',
                    'C02',
                    'C03',
                    'C04',
                    'C05',
                    'C06',
                    'D11',
                    'D12',
                    'D13',
                    'D14',
                    'D15',
                    'D16',
                    'D17',
                    'D18',
                    'D19',
                    'D20',
                    'D22',
                    'D23',
                    'E01',
                    'E02',
                    'E03',
                    'E04',
                    'F01',
                    'F02',
                    'F03',
                    'F04',
                    'F05',
                    'F13',
                    'F14',
                    'F22',
                    'F23',
                    'F24',
                ];
            default:
                return [];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.outsourcing-batch-import-dialog.ah-detail-dialog {
    .el-progress__text {
        margin-left: 70px;
    }
}
</style>

<style lang="scss">
.outsourcing-batch-import-dialog {
    .el-progress__text {
        margin-left: 15px;
    }
}
</style>
